<template>
  <span class="metricContainer">
    <NumeraiTooltip :text="tooltipText">
      <span class="label">
        {{ label }}
      </span>
    </NumeraiTooltip>
    <span class="value">
      <slot>{{ value }}</slot>
    </span>
  </span>
</template>

<script>
import NumeraiTooltip from '@/components/shared/NumeraiTooltip'

export default {
  components: {
    NumeraiTooltip,
  },
  props: {
    label: { type: String, default: '' },
    value: { type: String, default: '' },
    tooltipText: { type: String, default: '' },
    ratingTip: { type: Boolean, default: true },
    isPercentage: { type: Boolean, default: false },
  },
  computed: {},
}
</script>
<style scoped>
.metricContainer {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  color: var(--color-tertiary);
  font-weight: 500;
  transition: 0.2s;
}
.label {
  margin-right: 12px;
}
.value {
  color: var(--color-secondary);
  font-family: var(--number-font);
}
</style>
